import { Button } from '@quadralize/ui'
import { Magnifier } from '@solar-icons/react'
import { useTranslation } from 'react-i18next'
import { ErrorLayout } from '../components/error-layout'

export function NotFound() {
  const { t } = useTranslation('error')

  return (
    <ErrorLayout
      code={t('notFound.code')}
      title={t('notFound.title')}
      description={t('notFound.description')}
      icon={<Magnifier />}
      errorCode={t('notFound.errorCode')}
      showHomeButton={false}
      actions={
        <Button size="lg" onClick={() => window.location.assign('/')}>
          {t('notFound.backHome')}
        </Button>
      }
    />
  )
}
